<template>
    <div class="content-text" v-html="text" ></div>
</template>
<script>
export default {
    name: 'ContentText',
    props: {
        text: String
    }
}
</script>